import { getDefaultConfig } from "@constants/shared";

export interface UnlinkedExternalAccount {
    id: number;
    accountNumber: string;
    accountSourceName: string;
    portfolioName: string;
    cashAccountsCount: number;
    securityBalancesCount: number;
    cashAccountBalancesCount: number;
    tradeAccountsCount: number;
    tradeSetsCount: number;
    custodianReportsCount: number;
    portfolioBalancesCount: number;
    totalLinkedAccounts: number;
}

export interface LinkAccountRequest {
    clientId: number;
}

export class UnlinkedExternalAccountsRepo {
    static $inject = ["$http", "config"];

    constructor(
        private $http: angular.IHttpService,
        private config: any
    ) {}

    getUnlinkedExternalAccounts() {
        let config = getDefaultConfig();
        return this.$http.get(`${this.config.portfolioUrl}/UnlinkedExternalAccounts`, config);
    }

    linkAccountToClient(accountId: number, clientId: number) {
        let config = getDefaultConfig();
        return this.$http.post(
            `${this.config.portfolioUrl}/UnlinkedExternalAccounts/${accountId}/LinkToClient`,
            clientId,
            config
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/portfolios/unlinked-external-accounts.repo.ts